<app-drag-handle />

<div class="passport-login">

    <div class="passport-login__header">
        <h3 class="ci-heading-h6-semibold">{{ 'Pasaporte digital' | translate }}</h3>
        <ci-icon 
            (click)="dismissBottomSheet()" 
            name="close" 
            scale="1x" 
        />
    </div>

    <div class="passport-login__body">
        @if(bottomSheetData.image?.[lang()]){
            <div class="passport-login__body__image-wrapper">
                <img [src]="bottomSheetData.image[lang()]" />
            </div>
        }

        @if(bottomSheetData.description?.[lang()]){
            <div class="passport-login__body__content">
                <p 
                    class="ci-caption-regular" 
                    [innerHTML]="bottomSheetData.description[lang()]"
                >
                </p>
                <p (click)="openPassportGuide()" class="ci-paragraph-p1-regular how-work">
                    {{ '¿Cómo funciona el pasaporte digital?' | translate }}
                </p>
            </div>
        }

        <div class="passport-login__body__action-buttons">
            <ci-button 
                (click)="login()" 
                class-name="ci-btn-primary-m-filled" 
                type="button" 
                [aria-label]="'Iniciar sesión' | translate"
            >
                {{ 'Iniciar sesión' | translate }}
            </ci-button>
            <ci-button 
                (click)="dismissBottomSheet()" 
                class-name="ci-btn-primary-m-outlined" 
                type="button" 
                [aria-label]="'No, gracias' | translate"
            >
                {{ 'No, gracias' | translate }}
            </ci-button>
        </div>
    </div>
</div>